export enum ReasonType {
	unknown = "unknown",
	favorite = "toggleFavorite",
}

export const stringToReasonType = (value: string): ReasonType => {
	const isValidReason = Object.values(ReasonType).includes(value as ReasonType);

	return isValidReason ? (value as ReasonType) : ReasonType.unknown;
};
